import { FC } from 'react';
import { useLocation, useParams, Redirect } from 'react-router-dom';
import { Content } from '@/components/layout/Content';
import { NotFound } from '@/components/NotFound';
import { LoadingPage } from '@/components/LoadingPage';
import { useSession } from '@/components/SessionProvider';
import { useQuery } from '@/hooks/graphql/useQuery';
import { useNotify } from '@/hooks/useNotify';
import { parseBackUrl } from '@/utils/url';
import { EditForm } from './parts/EditForm/EditForm';
import {
  USER,
  UserQueryResult,
  UserQueryVariables,
  LMS_USER_ROLE,
  LmsUserRoleQueryResult,
  LmsUserRoleQueryVariables
} from './query';

interface SearchParams {
  id: string;
}

export const EditUser: FC = () => {
  const notify = useNotify();
  const { user: currentUser } = useSession();

  const { id } = useParams<SearchParams>();
  const location = useLocation();

  const { data, loading } = useQuery<UserQueryResult, UserQueryVariables>(USER, {
    variables: { id },
    fetchPolicy: 'no-cache'
  });
  const user = data?.client?.user;

  let lmsUserRole: string | undefined = undefined;
  try {
    const lmsUserRoleQuery = useQuery<LmsUserRoleQueryResult, LmsUserRoleQueryVariables>(LMS_USER_ROLE, {
      variables: { identifier: user?.email ?? '' },
      fetchPolicy: 'no-cache',
      skip: !user
    });
    if (lmsUserRoleQuery.data) {
      lmsUserRole = lmsUserRoleQuery.data.lmsUser.clientRole;
    }
  } catch {
    // 取得失敗時 (労務側に管理者が存在しない場合、社員権限に降格している場合、通信エラーなど) はエラーを出さずに権限欄の表示を諦める
  }

  if (!loading && !user) {
    return <NotFound />;
  }

  if (user && user.id === currentUser.id) {
    notify('自分自身の権限を変更することはできません', 'error');
    return <Redirect to={parseBackUrl(location, '/settings/users')} />;
  }

  return (
    <>
      <div className="l-title-wrap">
        <h1 className="m-title-main">権限の編集</h1>
      </div>
      {user ? (
        <Content size="xs">
          <EditForm user={user} lmsUserRole={lmsUserRole} />
        </Content>
      ) : (
        <LoadingPage />
      )}
    </>
  );
};
